import { createRouteRef, createSubRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const eventDetailsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/events/:eventId',
});
